const paths = {
  protocolsList: '/listProtocol'
};

export default paths;
